<template>

<div class="tabs">

	<div class="tabs-item" v-for="tab in tabs" :key="tab.value" :class="{'is-active': active === tab.value}" v-on:click="$emit('change', tab.value)">

        <div>{{ tab.text }}</div><div class="tabs-item-count" v-if="tab.count">{{ tab.count }}</div>

    </div>

</div>

</template>

<script>

export default {

    props: ['tabs', 'active']

}

</script>

<style scoped>

.tabs {
    grid-column: span 6;
    display: flex;
    border-bottom: 1px solid #ddd;
    height: 64px;
}

.tabs:before {
    position: absolute;
    content: '';
    display: block;
    left: -40px;
    right: -40px;
    height: 1px;
    bottom: -1px;
    width: 100%;
    background-color: #ddd;
}

.tabs-item {
    padding: 0px 20px;
    height: 64px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 300;
    border-radius: 4px 4px 0px 0px;
    border: 1px solid transparent;
    margin-right: 2px;
    align-items: center;
    user-select: none;
    display: flex;
}

.is-mobile .tabs-item {
    padding: 0px 10px;
    font-size: 14px;
    padding: 0px 10px;
    line-height: 18px;
}

.tabs-item:hover {
    background-color: #ddd;
}

.tabs-item.is-active {
    padding: 0px 20px;
    color: #333;
    font-weight: 500;
    background-color: #fff;
    border-color: #ddd;
    border-bottom-color: #fff;
}

.is-mobile .tabs-item.is-active {
    padding: 0px 10px;
}

.tabs-item-count {
    border-radius: 4px;
    background-color: #ccc;
    height: 24px;
    line-height: 24px;
    padding: 0px 4px;
    color: #333;
    font-size: 12px;
    margin-left: 10px;
}

</style>